// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hydrogen-projects-chart-wrapper .title{font-size:.875rem;text-align:center}.hydrogen-projects-chart-wrapper .no-data{font-size:.875rem;text-align:center;color:red;padding:20px 10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
